export const SUBSIDIES = [
  // ── 既存6件 ──────────────────────────────────────
  {
    id: 1,
    name: "経営所得安定対策（ゲタ・ナラシ対策）",
    category: "収入安定",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["水田", "畑作", "野菜", "果樹"],
    regions: ["全国"],
    maxAmount: "変動（収入差額補填）",
    deadline: "毎年2月頃",
    summary: "農業収入が減少した際に、標準的収入との差額の一定割合を補填する制度。",
    requirements: ["農業共済への加入", "青色申告", "経営規模の基準を満たすこと"],
    applyUrl: "https://www.maff.go.jp/j/kobetu_ninaite/n_seisaku/keiei_antei.html",
    icon: "💰",
  },
  {
    id: 2,
    name: "農業次世代人材投資資金（就農促進資金）",
    category: "就農支援",
    target: ["新規就農者"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "最大150万円/年（最長3年間）",
    deadline: "随時（市町村窓口）",
    summary: "新規就農者の経営が安定するまでの間、資金を交付する制度。",
    requirements: ["50歳未満", "認定新規就農者であること", "独立・自営就農または雇用就農"],
    applyUrl: "https://www.maff.go.jp/j/new_farmer/n_syunou/roudou.html",
    icon: "🌱",
  },
  {
    id: 3,
    name: "強い農業・担い手づくり総合支援交付金",
    category: "設備投資",
    target: ["個人農家・家族経営", "法人農家", "新規就農者"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "補助率1/2〜2/3（上限あり）",
    deadline: "都道府県により異なる",
    summary: "農業用機械・施設の導入費用を補助する制度。スマート農業機器も対象。",
    requirements: ["認定農業者または認定新規就農者", "事業計画の策定"],
    applyUrl: "https://www.maff.go.jp/j/kobetu_ninaite/n_seisaku/strong_nougyou.html",
    icon: "🚜",
  },
  {
    id: 4,
    name: "農業経営基盤強化資金（スーパーL資金）",
    category: "融資",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "個人3億円・法人10億円",
    deadline: "随時",
    summary: "農業の規模拡大や施設整備のための低利融資。当初5年間無利子も可能。",
    requirements: ["認定農業者", "農業経営改善計画の認定"],
    applyUrl: "https://www.maff.go.jp/j/kobetu_ninaite/n_seisaku/superL.html",
    icon: "🏦",
  },
  {
    id: 5,
    name: "スマート農業技術の開発・実証プロジェクト",
    category: "スマート農業",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "補助率1/2（上限：課題による）",
    deadline: "公募による",
    summary: "ロボット農機・AI・ICT等のスマート農業技術導入を支援。",
    requirements: ["実証計画の策定", "農研機構等との連携"],
    applyUrl: "https://www.maff.go.jp/j/kanbo/smart/",
    icon: "🤖",
  },
  {
    id: 6,
    name: "有機農業への転換支援",
    category: "環境対応",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "補助率1/2〜3/4",
    deadline: "都道府県により異なる",
    summary: "有機農業や環境保全型農業への転換に係る費用を支援。",
    requirements: ["有機JAS認証取得予定または取得済み", "転換計画の策定"],
    applyUrl: "https://www.maff.go.jp/j/seisan/kankyo/yuuki/",
    icon: "🌿",
  },

  // ── 今回追加：個人農家向け8件 ────────────────────
  {
    id: 7,
    name: "就農準備資金（農業次世代人材投資資金）",
    category: "就農支援",
    target: ["新規就農者", "就農予定（まだ農業をしていない）"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "最大150万円/年（最長2年間）",
    deadline: "随時（市町村窓口）",
    summary: "就農前の研修期間中に生活費として最大150万円/年を給付。49歳以下が対象。",
    requirements: ["49歳以下", "認定研修機関での研修受講", "就農計画の認定"],
    applyUrl: "https://www.maff.go.jp/j/new_farmer/n_syunou/roudou.html",
    icon: "📚",
  },
  {
    id: 8,
    name: "経営発展支援事業",
    category: "就農支援",
    target: ["新規就農者"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "機械・施設費の1/2以内（上限150万円）",
    deadline: "随時（市町村窓口）",
    summary: "認定新規就農者が農業機械・施設を購入する際の費用を最大150万円補助する制度。",
    requirements: ["認定新規就農者", "青色申告への移行計画"],
    applyUrl: "https://www.maff.go.jp/j/new_farmer/n_syunou/hatten.html",
    icon: "📈",
  },
  {
    id: 9,
    name: "青年等就農資金（無利子融資）",
    category: "融資",
    target: ["新規就農者", "就農予定（まだ農業をしていない）"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "最大3,700万円（無利子）",
    deadline: "随時",
    summary: "認定新規就農者が農地・農業機械・施設等を取得するための無利子融資制度。",
    requirements: ["45歳未満（一部50歳未満）", "認定新規就農者"],
    applyUrl: "https://www.maff.go.jp/j/new_farmer/n_kasituke/index2.html",
    icon: "💳",
  },
  {
    id: 10,
    name: "収入保険",
    category: "収入安定",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "収入減少分の最大90%を補填",
    deadline: "毎年10月頃（翌年1月加入開始）",
    summary: "自然災害・価格下落など全リスクによる収入減少を補填。青色申告が必要。",
    requirements: ["青色申告を1年以上継続", "農業共済組合（NOSAI）への加入申請"],
    applyUrl: "https://nosai-zenkokuren.or.jp/syunyuhoken-site.html",
    icon: "🛡️",
  },
  {
    id: 11,
    name: "農業共済（NOSAI）",
    category: "収入安定",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["水田", "野菜（施設）", "果樹", "畜産"],
    regions: ["全国"],
    maxAmount: "損害額に応じて補填（掛金の一部を国が負担）",
    deadline: "作付け前（時期は作目により異なる）",
    summary: "自然災害による農作物・施設・家畜の損害を補填する公的保険。掛金の一部を国が補助。",
    requirements: ["農業共済組合（NOSAI）への加入", "一定の作付け面積・飼養頭数"],
    applyUrl: "https://www.maff.go.jp/j/keiei/nogyohoken/contact.html",
    icon: "☔",
  },
  {
    id: 12,
    name: "多面的機能支払交付金",
    category: "環境対応",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["水田", "畑作"],
    regions: ["全国"],
    maxAmount: "水田：10aあたり3,000〜6,000円/年",
    deadline: "毎年4月頃（市町村窓口）",
    summary: "農地・農業用水等の保全管理や農村環境の保全活動に対して交付金を支払う制度。",
    requirements: ["地域活動組織の結成・参加", "農地・水利施設の保全管理活動の実施"],
    applyUrl: "https://www.maff.go.jp/j/nousin/kanri/tamen_siharai.html",
    icon: "💧",
  },
  {
    id: 13,
    name: "中山間地域等直接支払制度",
    category: "収入安定",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["全作目"],
    regions: ["中山間地域"],
    maxAmount: "急傾斜農地：田21,000円/10a・畑11,500円/10a",
    deadline: "毎年4〜5月頃（市町村窓口）",
    summary: "山間部など条件不利地域の農地を維持する農業者に交付金を支払う制度。",
    requirements: ["中山間地域等の対象農地での農業", "5年以上の営農継続協定の締結"],
    applyUrl: "https://www.maff.go.jp/j/nousin/tyusan/siharai_seido/index.html",
    icon: "⛰️",
  },
  {
    id: 14,
    name: "鳥獣被害防止総合対策交付金",
    category: "設備投資",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "防護柵等の整備費：定額（市町村経由）",
    deadline: "市町村により異なる",
    summary: "イノシシ・シカ・クマ等による農作物被害を防ぐための防護柵設置・駆除活動を支援。",
    requirements: ["被害防止計画を策定した市町村の区域内", "市町村への申請"],
    applyUrl: "https://www.maff.go.jp/j/seisan/tyozyu/higai/index.html",
    icon: "🦌",
    wildlifeOnly: true,
  },

  // ── 今回追加：カテゴリ拡充8件（6次産業化・輸出・税制・農福連携・農地活用・経営支援 等） ──
  {
    id: 15,
    name: "農山漁村発イノベーション対策（6次産業化支援）",
    category: "6次産業化",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "補助率1/2以内（事業内容による）",
    deadline: "公募による（年1〜2回程度）",
    summary: "農産物の加工・直売・農家レストランなど、生産＋加工＋販売に取り組む際の施設整備や商品開発を支援。",
    requirements: ["事業計画の策定", "地域資源を活用した取り組みであること"],
    applyUrl: "https://www.maff.go.jp/j/shokusan/sanki/6jika.html",
    icon: "🏪",
  },
  {
    id: 16,
    name: "農林水産物・食品輸出促進対策",
    category: "輸出支援",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "事業内容による（施設整備・販路開拓等）",
    deadline: "公募による",
    summary: "農産物の海外輸出に向けた産地づくり・施設整備・海外販路開拓などを支援。GFP（農林水産物・食品輸出プロジェクト）への登録から始められる。",
    requirements: ["輸出事業計画の策定（事業による）", "GFP登録（無料）推奨"],
    applyUrl: "https://www.maff.go.jp/j/shokusan/export/",
    icon: "🚢",
  },
  {
    id: 17,
    name: "農業経営基盤強化準備金制度",
    category: "税制優遇",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "交付金の積立額を損金・必要経費に算入可",
    deadline: "確定申告時（毎年）",
    summary: "経営所得安定対策などの交付金を将来の農地・機械購入のために積み立てると、その分を損金・必要経費にできる節税制度。",
    requirements: ["認定農業者または認定新規就農者", "青色申告", "農業経営改善計画等への記載"],
    applyUrl: "https://www.maff.go.jp/j/kobetu_ninaite/n_seido/seido_junbikin.html",
    icon: "🧾",
  },
  {
    id: 18,
    name: "農山漁村振興交付金（農福連携支援）",
    category: "農福連携",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "事業内容による（施設整備・専門人材活用等）",
    deadline: "公募による",
    summary: "障がい者等が農業で活躍する「農福連携」に取り組む際の施設整備や、専門人材による支援を受けられる制度。",
    requirements: ["農福連携の取組計画の策定", "福祉事業者等との連携（事業による）"],
    applyUrl: "https://www.maff.go.jp/j/nousin/kouryu/noufuku.html",
    icon: "🤝",
  },
  {
    id: 19,
    name: "農地バンク（農地中間管理機構）活用・協力金",
    category: "農地活用",
    target: ["個人農家・家族経営", "法人農家", "新規就農者"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "地域・農地面積による（貸し手側に協力金）",
    deadline: "随時（都道府県の機構窓口）",
    summary: "農地を借りて規模拡大したい農家と、貸したい農地所有者をつなぐ公的制度。まとまった農地を安心して借りられる。",
    requirements: ["農地中間管理機構を通じた貸借", "地域計画（目標地図）との整合"],
    applyUrl: "https://www.maff.go.jp/j/keiei/koukai/kikou/",
    icon: "🗾",
  },
  {
    id: 20,
    name: "農業経営・就農支援センター（無料経営相談）",
    category: "経営支援",
    target: ["個人農家・家族経営", "法人農家", "新規就農者", "就農予定（まだ農業をしていない）"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "相談無料（税理士・中小企業診断士等の専門家派遣）",
    deadline: "随時",
    summary: "各都道府県に設置された公的相談窓口。経営改善・法人化・税務・就農など、専門家に無料で相談できる。",
    requirements: ["特になし（農業者・就農希望者なら誰でも利用可）"],
    applyUrl: "https://www.maff.go.jp/j/keiei/keieisien/",
    icon: "👨‍🏫",
  },
  {
    id: 21,
    name: "雇用就農資金",
    category: "就農支援",
    target: ["法人農家", "新規就農者"],
    crops: ["全作目"],
    regions: ["全国"],
    maxAmount: "最大60万円/年（最長4年間・雇用主に助成）",
    deadline: "年数回の募集期間あり",
    summary: "農業法人等が新規就農者を雇用して研修を行う場合に、雇用主に資金を助成する制度。",
    requirements: ["50歳未満の就農希望者の新規雇用", "研修計画の策定"],
    applyUrl: "https://www.maff.go.jp/j/new_farmer/",
    icon: "👥",
  },
  {
    id: 22,
    name: "環境保全型農業直接支払交付金",
    category: "環境対応",
    target: ["個人農家・家族経営", "法人農家"],
    crops: ["水田", "畑作", "野菜", "果樹"],
    regions: ["全国"],
    maxAmount: "取組内容ごとに10aあたり定額（例：有機農業）",
    deadline: "毎年6月頃（市町村窓口）",
    summary: "化学肥料・農薬の低減や有機農業など、環境にやさしい農業の取組面積に応じて交付金を受け取れる制度。",
    requirements: ["化学肥料・化学合成農薬の5割低減等の取組", "販売を目的とした生産"],
    applyUrl: "https://www.maff.go.jp/j/seisan/kankyo/kakyou_chokubarai/mainp.html",
    icon: "🌏",
  },
];

export const CATEGORY_COLORS = {
  収入安定:    { bg: "#e8f5e9", text: "#2e7d32" },
  就農支援:    { bg: "#fff3e0", text: "#e65100" },
  設備投資:    { bg: "#e3f2fd", text: "#1565c0" },
  融資:        { bg: "#f3e5f5", text: "#6a1b9a" },
  スマート農業: { bg: "#e0f7fa", text: "#006064" },
  環境対応:    { bg: "#f1f8e9", text: "#33691e" },
  "6次産業化": { bg: "#fff8e1", text: "#f57f17" },
  税制優遇:    { bg: "#fce4ec", text: "#880e4f" },
  輸出支援:    { bg: "#e8eaf6", text: "#283593" },
  農福連携:    { bg: "#f3e5f5", text: "#4a148c" },
  農地活用:    { bg: "#e0f2f1", text: "#004d40" },
  経営支援:    { bg: "#efebe9", text: "#4e342e" },
};

export const EXPENSE_CATEGORIES = [
  "農薬・肥料", "農業機械", "種苗・種子",
  "燃料費", "水道光熱費", "雇用労務費", "修繕費", "その他",
];

export const PREFECTURES = [
  "北海道", "青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県",
  "茨城県", "栃木県", "群馬県", "埼玉県", "千葉県", "東京都", "神奈川県",
  "新潟県", "富山県", "石川県", "福井県", "山梨県", "長野県", "岐阜県", "静岡県", "愛知県",
  "三重県", "滋賀県", "京都府", "大阪府", "兵庫県", "奈良県", "和歌山県",
  "鳥取県", "島根県", "岡山県", "広島県", "山口県",
  "徳島県", "香川県", "愛媛県", "高知県",
  "福岡県", "佐賀県", "長崎県", "熊本県", "大分県", "宮崎県", "鹿児島県", "沖縄県",
];

// core: true の質問だけで一度結果を出す（入力の負担を減らす）。残りは結果画面から任意で答える。
// type: "pref"＝都道府県を選ぶ＋市町村を書く ／ "text"＝自由記入（スキップ可） ／ 指定なし＝選択肢をタップ
export const QUIZ_QUESTIONS = [
  {
    id: "prefecture",
    core: true,
    type: "pref",
    question: "農業をされている都道府県・市町村を教えてください",
    icon: "📍",
  },
  {
    id: "farmer_type",
    core: true,
    question: "農業の経営形態を教えてください",
    icon: "🌾",
    options: ["個人農家・家族経営", "法人農家", "新規就農者（就農5年以内）", "就農予定（まだ農業をしていない）"],
  },
  {
    id: "certification",
    core: true,
    question: "認定資格はお持ちですか？",
    icon: "📜",
    options: ["認定農業者（市町村に認定済み）", "認定新規就農者", "いずれも持っていない", "わからない"],
  },
  {
    id: "main_crop",
    core: true,
    question: "主に作っているもの・畜産の種類を教えてください",
    icon: "🌱",
    options: ["水稲・米", "野菜（露地）", "野菜（施設）", "果樹", "畑作（麦・大豆・いも等）", "畜産（肉用牛・養豚・養鶏）", "酪農", "その他・複合経営"],
  },
  {
    id: "crop_items",
    core: true,
    type: "text",
    question: "主な栽培品目を教えてください",
    hint: "品目ごとに補助金が用意されていることがあります。わかる範囲で大丈夫です。",
    placeholder: "例：じゃがいも、玉ねぎ、ブロッコリー",
    icon: "🥔",
  },
  {
    id: "workers",
    core: true,
    question: "農業に従事している人数は？（ご家族・従業員を含む）",
    icon: "👥",
    options: ["1人", "2〜3人", "4〜9人", "10人以上"],
  },
  {
    id: "purpose",
    core: true,
    question: "一番やりたいこと・困っていることはどれですか？",
    icon: "🎯",
    options: [
      "農機・ハウス・設備を新しく買いたい",
      "天候や価格変動で収入が不安定",
      "農業を始めたばかり・お金が足りない",
      "ドローン・スマート農業を導入したい",
      "農薬を減らして有機農業に転換したい",
      "加工・直売・農家レストランを始めたい",
      "農産物を海外に売りたい",
      "節税・税金対策をしたい",
      "農地を広げて規模拡大したい",
      "経営の専門家に相談したい",
      "障がい者・多様な人と農業をしたい",
    ],
  },
  {
    id: "contract_status",
    question: "⚠️ その投資（機械・設備等）はまだ契約・発注・購入していませんか？",
    icon: "📝",
    options: [
      "まだ契約・発注・購入していない（これから検討）",
      "見積もりは取ったがまだ契約していない",
      "すでに契約・発注・購入済み",
      "わからない・確認中",
    ],
  },
  {
    id: "estimate_ready",
    question: "見積書（購入予定の機械・設備の金額が分かる書類）はありますか？",
    icon: "📄",
    options: [
      "すでに見積書を取得済み",
      "これから見積もりを取る予定",
      "まだ何も取っていない",
      "補助金の対象か確認してから取る予定",
    ],
  },
  {
    id: "farm_experience",
    question: "農業の経験年数を教えてください",
    icon: "📅",
    options: ["就農1年未満（これから）", "1〜3年（新規就農期）", "4〜9年", "10年以上（ベテラン）"],
  },
  {
    id: "age_range",
    question: "年齢を教えてください",
    icon: "🎂",
    options: ["39歳以下", "40〜49歳", "50〜64歳", "65歳以上"],
  },
  {
    id: "farm_size",
    question: "農地の合計面積はどのくらいですか？",
    icon: "📐",
    options: ["1ha未満（小規模）", "1〜5ha", "5〜10ha", "10ha以上（大規模）"],
  },
  {
    id: "blue_tax",
    question: "青色申告をしていますか？",
    icon: "📋",
    options: ["はい、青色申告しています", "いいえ、白色申告です", "まだ確定申告していない（新規就農予定）"],
  },
  {
    id: "region",
    question: "農地の地域はどちらに当てはまりますか？",
    icon: "⛰️",
    options: ["平地（平野部・都市近郊）", "中山間地域（山間部・傾斜地）", "離島・沿岸部", "わからない"],
  },
  {
    id: "wildlife_damage",
    question: "鳥獣（イノシシ・シカ・クマ等）による農作物被害はありますか？",
    icon: "🦌",
    options: ["被害を受けている", "被害はない・少ない", "わからない"],
  },
];
